<template>
  <div class="submit">
    <md-button
      type="submit"
      class="md-raised md-primary"
      :disabled="submitted != false && submitted != 'error'"
      :md-ripple="false"
      @click="validate()"
    >
      <span v-if="submitted == false">Enviar capítulo</span>
      <loader v-else-if="submitted == 'loading'"/>
      <span v-else-if="submitted == 'error'">Erro! Tente novamente.</span>
      <span v-else>Enviado!</span>
    </md-button>
  </div>
</template>

<script>
import LogRocket from "logrocket";
import linkVal from "@/assets/js/linkValidation";
import loader from "@/components/shared/loader";
import call from "@/api/calls";
import bus from "@/api/bus";
import axios from "axios";

const log = (error, method, data) => {
  LogRocket.captureException(error, {
    extra: {
      method,
      data
    }
  });
}

export default {
  name: "createChapter",
  components: {
    loader
  },
  props: ['chapter', 'place', 'mode'],
  data: function() {
    return {
      submitted: false,
      newChapter: null,
      newPlace: null,
      user: JSON.parse(localStorage.getItem('user')),
      response: {
        group: { ok: false },
        chapter: { ok: false },
        place: { ok: false },
        profile: { ok: false },
        tags: { ok: false },
        edit: { ok: false }
      }
    };
  },
  computed: {
    isNewPlace() {
      return typeof this.place.id == 'string';
    }
  },
  methods: {
    validate() {
      this.submitted = "loading";
      this.newChapter = JSON.parse(JSON.stringify(this.chapter));
      this.newPlace = JSON.parse(JSON.stringify(this.place));

      let invalidData = {};

      if (this.place) {
        if (this.place.id)
          this.newChapter.group = this.place.id;
      }
      else {
        this.error = "No place selected or created!";
        // this.submitted = 'error';
        // return bus.emit.invalidData({ place: this.error, chapter: [] });
      }

      invalidData.place = this.validatePlace(this.newPlace);

      invalidData.chapter = this.validateChapter(this.newChapter);

      if (this.newChapter && Array.isArray(this.newChapter.media)) {
        if (this.newChapter.media.length == 1 && this.newChapter.media[0].url == "") {
          this.newChapter.media = [];
          invalidData.media = [];
        }
        else  invalidData.media = this.validMediaLinks(this.newChapter.media, true, false);
      }
      else invalidData.media = []

      if (invalidData.place.length > 0 || invalidData.chapter.length > 0 || invalidData.media.length > 0) {
        this.submitted = 'error';
        LogRocket.warn("Error on form submit: ", invalidData);
        return bus.emit.invalidData(invalidData);
      }

      this.mode != 'edit'? this.addPost() : this.editChapter();
    },

    validateChapter(chapter) {
      // marcar pontos que faltam e mandar pro form
      let invalidFields = [];
      if (!chapter)
        chapter = {};
      if (!chapter.title)
        invalidFields.push("title");
      if (!chapter.author)
        invalidFields.push("author");
      if (!chapter.position)
        invalidFields.push("position");

      return invalidFields;
    },

    validMediaLinks(links, index = false, valid = true) {
      let validMedia = [];
      for(let i = 0; i < links.length; i++) {
        if(!!linkVal.isValid(links[i].url) == valid) {
          validMedia.push(index? i : links[i]);
        }
      }
      return validMedia;
    },

    validatePlace(place) {
      // marcar pontos que faltam e mandar pro form
      // (considerar se lugar tem id (this.place.id))
      let invalidFields = [];
      if (!place) {
        invalidFields.push("name", "position");
        return invalidFields;
      }
      if (place.id)
        return invalidFields;
      if (!place.name)
        invalidFields.push("name");
      if (!place.position)
        invalidFields.push("position");

      return invalidFields;
    },

    addPost() {
      this.createPlace(this.newPlace)
        .then(group => {
          this.newChapter.group = group.id;
          this.newChapter.author = this.user.id;
          return this.manageCreate(this.newChapter)
        })
        .then(results => {
          this.submitted = true;
          this.response.array = results;
          return this.$router.push({
            name: "chapter",
            params: { id: this.response.chapter.result.id }
          });
        })
        .catch(error => {
          this.submitted = "error";
          log(error, "addPost()", null);
          this.response.error = error;
        });
    },

    editChapter() {
      this.newChapter.id = this.$route.params.id;

      if (!this.newChapter.title || !this.newChapter.position)
        throw new Error("No title or position.");

      call.chapter.edit(this.newChapter)
      .then(updated => {
        this.submitted = true;
        this.response.edit.ok = true;
        this.response.edit.result = updated;
        this.$router.go();
      })
      .catch(error => {
        this.submitted = 'error';
        log(error, "editChapter()", null);
        this.response.error = error;
      })
    },

    createPlace(newPlace) {
      if (newPlace && newPlace.id)
        return Promise.resolve(this.response.group.result = newPlace);
      else if (this.response.group.ok && this.response.group.result)
        return Promise.resolve(this.response.group.result);
      else if (!newPlace || !newPlace.name)
        return Promise.reject(new Error("No name provided for group."));
      else if (!this.response.group.ok)
        return call.group.create(newPlace)
        .then(group => {
          this.response.group.ok = true;
          this.response.group.result = group;
          return group;
        });
      else  Promise.reject(new Error("Uknown error on createPlace"));
    },

    manageCreate(newChapter) {
      if (!newChapter.author || !newChapter.title)
        return Promise.reject(new Error("No author or title."));

      return (this.response.chapter.ok == false
        ? this.createChapter(newChapter)
        : Promise.resolve(this.response.chapter.result)
      ).then(chapter => axios.all(this.requestArray(chapter)));
    },

    requestArray(chapter) {
      let requests = [];
      if (!this.response.profile.ok)
        requests.push(this.addToProfile(chapter.author, chapter.id));

      if (!this.response.place.ok && this.response.group.result) {
        requests.push(this.addToPlace(this.response.group.result.id, chapter.id));
      } else
        this.response.place.log =
          "No place to add. Skipping... #TODO: add to nearest place.";

      // if (!this.response.tags.ok && this.tags && this.tags.length > 0)
      //   requests.push(this.addTags(this.tags, chapter.id));
      // else this.response.tags.log = "No tags to add. Skipping...";

      return requests;
    },

    createChapter(newChapter) {
      return call.chapter.create(newChapter).then(chapter => {
        this.response.chapter.ok = true;
        this.response.chapter.result = chapter;
        return chapter;
      });
    },

    addToPlace(placeId, chapterId) {
      return call.group
        .addChapter(placeId, chapterId)
        .then(placeId => {
          this.response.place.ok = true;
          this.response.place.result = placeId;
          return placeId;
        })
        .catch(error => {
          this.submitted = "error";
          log(error, "addToPlace(placeId, chapterId)", {
            placeId,
            chapterId
          });
          return (this.response.place.error = error);
        });
    },

    addToProfile(author, chapterId) {
      return call.profile
        .addChapter(author, chapterId)
        .then(profileId => {
          this.response.profile.ok = true;
          this.response.profile.result = profileId;
          return profileId;
        })
        .catch(error => {
          this.submitted = "error";
          log(error, "addToProfile(author, chapterId)", {
            author,
            chapterId
          });
          return (this.response.profile.error = error);
        });
    },

    addTags(chapterId, tags) {
      return call.tag
        .addChapterTags(chapterId, tags)
        .then(tags => {
          this.response.tags.ok = true;
          this.response.tags.result = tags;
          return tags;
        })
        .catch(error => {
          this.submitted = "error";
          log(error, "addTags(chapterId, tags)", { chapterId });
          return (this.response.tags.error = error);
        });
    },

  }
};
</script>
